<template>
  <div class="agreement">
    <!--顶部导航-->
    <div v-if="this.agrType != '1'">
      <Navbar title="协议内容" :isSpecialBack="true" @goBack="goback" />
    </div>
    <div class="content-wrap">
      <div class="constnet" v-if="protocolContent.length == 1">
        <div class="protocol-content">
          <div class="title">
            {{ protocolContent[0].configName }}
          </div>
          <div class="content" v-html="protocolContent[0].configValue"></div>
        </div>
      </div>
      <div v-else>
        <van-tabs
          v-model="active"
          scrollspy
          sticky
          offset-top="56px"
          :line-width="0"
          :line-height="0"
        >
          <van-tab v-for="(item, index) in protocolContent" :key="index">
            <template #title>
              <div class="tab-title" :class="{ active: active === index }">
                {{ item.configName }}
              </div>
            </template>
            <div class="protocol-content">
              <div class="title">
                {{ item.configName }}
              </div>
              <div class="content" v-html="item.configValue"></div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <div ref="contentSentinel" class="content-sentinel"></div>
    <div
      v-if="this.routerName !== 'orderDetails' && isRead == '1'"
      class="footer-wrap"
    >
      <div
        class="btn"
        :class="{ disabled: !isdisabled || !isIntersecting }"
        @click="handleClick"
      >
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import {
  getProtocol,
  getLoginProtocol,
  getIdCardProtocol,
  getBorrowProtocol,
} from "@/api/index.js";
import { getLocalStorageData } from "@/common/index";

export default {
  name: "agreement",
  components: {
    Navbar,
  },
  data() {
    return {
      protocolContent: [],
      active: 0,
      text: "请滑动并阅读至底部",
      observer: null,
      timer: null,
      time: 0,
      isdisabled: false,
      isIntersecting: false,
      //路由名称
      routerName: "",
      agrType: "3",
      isRead: getLocalStorageData("agreementSigningConditions"),
      isLogin: "0",
    };
  },
  async activated() {
    this.getDetails();
  },
  async mounted() {
    this.getDetails();
  },
  beforeDestroy() {
    console.log("组件销毁前调用");
    // 页面销毁前必须注销监听器，防止内存泄漏
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // 获取协议详情
    getDetails(){
      this.routerName = this.$route.query.bankRouter || "Login";
      //根据协议类型获取协议内容
      this.agrType = this.$route.query.agrType || "";
      this.isLogin = this.$route.query.isLogin || "0";
      if (this.agrType == 5) {
        //获取借款协议信息
        let borrowProtocol = this.$store.state.bankInfo;
        getBorrowProtocol({
          type: this.agrType,
          bankCardId: borrowProtocol.id,
          borrowPurpose:this.$store.state.borrowPurpose || '个人消费',
        }).then((res) => {
          if (res.code === 2000) {
            this.protocolContent = res.data;
            this.initObserver();
            this.handleTimer();
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
        return;
      }
      if (this.agrType == 4) {
        //获取实名认证协议信息
        let realNameProtocol = this.$store.getters.realNameProtocol;
        getIdCardProtocol({
          type: this.agrType,
          username: realNameProtocol.ocrName,
          idCardNumber: realNameProtocol.ocrCardNo,
        }).then((res) => {
          if (res.code === 2000) {
            this.protocolContent = res.data;
            this.initObserver();
            this.handleTimer();
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
        return;
      }
      if (this.isLogin == "1") {
        getProtocol({ type: this.agrType }).then((res) => {
          if (res.code === 2000) {
            this.protocolContent = res.data;
            this.initObserver();
            this.handleTimer();
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
      } else {
        let params = {
          type: this.agrType
        }
        // 获取银行卡协议详情时，需要传递银行卡号和银行名称参数用来生成合同协议
        if(this.agrType == 6){
          params.bankNumber = this.$route.query.bankCard || "";
          params.bankName = this.$route.query.bankName || "";
        }
        getLoginProtocol(params).then((res) => {
          if (res.code === 2000) {
            this.protocolContent = res.data;
            this.initObserver();
            this.handleTimer();
          } else {
            this.$toast(res.msg || res.message || "请求失败");
          }
        });
      }
    },
    goback() {
      this.$router.back();
    },
    //处理点击事件
    handleClick() {
      this.$router.back();
      this.$store.commit("setIsChecked", true);
    },
    //监听contentSentinel元素是否出现在可视区域
    initObserver() {
      // 1. 获取 DOM 元素
      const target = this.$refs.contentSentinel;
      if (!target) return;

      // 2. 创建监听器实例
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.isIntersecting = true;
            if (this.time >= 5) {
              this.text = "我已阅读并同意";
            }
          } else {
            if (!this.isIntersecting) {
              this.isIntersecting = false;
            }
          }
        },
        {
          root: null, // 默认 null 表示相对于浏览器视口（viewport）
          threshold: 0, // 触发阈值。0.1 表示元素有 10% 面积进入视口时就触发回调
        },
      );

      // 3. 启动监听
      this.observer.observe(target);
    },
    //处理定时器回调
    handleTimer() {
      this.timer = setInterval(() => {
        this.time++;
        if (this.time >= 5) {
          if (this.isIntersecting) {
            this.text = "我已阅读并同意";
            clearInterval(this.timer);
            this.isdisabled = true;
          }
        } else {
          if (this.isIntersecting) {
            this.text = `还需要阅读${5 - this.time}秒`;
          }
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.agreement {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #fff;
}
.content-wrap {
  padding: 16px;
  word-break: break-all;
  overflow-wrap: break-word;
}
.tab-title {
  padding: 3px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-family: "Regular";
  color: rgba(51, 51, 51, 0.4);
  background: #ebebeb;
}
.active {
  background: #F24334;
  color: #fff;
}
.title {
  color: #000000;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
}
.content {
  font-size: 12px;
}
.footer-wrap {
  width: 100%;
  height: 110px;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  .btn {
    height: 50px;
    background: #F24334;
    border-radius: 30px;
    font-size: 18px;
    font-family: "Regular";
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 26px;
  }
  .disabled {
    background: #FFC2BD;
  }
}
.content-sentinel {
  height: 120px;
  width: 100%;
}
/* Vue 3 推荐写法 */
::v-deep(.van-tabs__line) {
  /* 初始时通过 transition 延迟显示，或者给个透明度，避开刚进页面的闪烁 */
  animation: fadeInLine 0.3s ease-in-out forwards;
  background: none !important;
}

@keyframes fadeInLine {
  0% {
    opacity: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
